export default __webpack_public_path__ + "static/media/revolt-player.88a776c2.gif";